import type { NetReplayModule } from './store';

export type RebuildDecision = {
  needsRebuild: boolean;
  shadowTrackChanged: boolean;
};

export type ExistingChunkManagerState = {
  starterIds: Array<string>;
  shadowgeojsonHash: string | null;
  startTime: number;
  endTime: number;
  netReplay: NetReplayModule;
};

export type NewEventState = {
  starters: Array<{ id: string }>;
  shadowgeojsonHash: string | null;
  startTime: number;
  endTime: number;
  netReplay: NetReplayModule;
};

function netReplayEquals(a: NetReplayModule, b: NetReplayModule): boolean {
  if (!a.enabled && !b.enabled) return true;
  if (!a.enabled || !b.enabled) return false;
  return a.syncOffset === b.syncOffset && a.syncTime.getTime() === b.syncTime.getTime();
}

export function shouldRebuildChunkManager(
  existing: ExistingChunkManagerState,
  incoming: NewEventState,
): RebuildDecision {
  const shadowTrackChanged = existing.shadowgeojsonHash !== incoming.shadowgeojsonHash;

  if (shadowTrackChanged) return { needsRebuild: true, shadowTrackChanged };

  if (existing.startTime !== incoming.startTime || existing.endTime !== incoming.endTime) {
    return { needsRebuild: true, shadowTrackChanged };
  }

  if (!netReplayEquals(existing.netReplay, incoming.netReplay)) {
    return { needsRebuild: true, shadowTrackChanged };
  }

  if (existing.starterIds.length !== incoming.starters.length) {
    return { needsRebuild: true, shadowTrackChanged };
  }
  for (let i = 0; i < existing.starterIds.length; i++) {
    if (existing.starterIds[i] !== incoming.starters[i].id) {
      return { needsRebuild: true, shadowTrackChanged };
    }
  }

  return { needsRebuild: false, shadowTrackChanged: false };
}
